module.exports = __webpack_public_path__ + "img/imgRemove02.ae6fb65c.png";